/*
This is the silver badge that represents a main number
or a lucky star in a ticket entry/card.
*/

import star from "../../assets/icons/star.svg";

export interface SlotProps {
  isStar: boolean;
  children?: React.ReactNode;
}

export default function Slot(props: SlotProps) {
  return (
    <div className="relative ~w-5/6 rounded-full ~m-0.4/0.5 flex justify-center bg-gradient-to-br from-white to-emperor text-cinder">
      <div className={`font-archb ~text-xs/sm ~leading-6/7`}>
        {props.children}
      </div>
      {props.isStar && (
        <img
          src={star}
          className="absolute ~h-2/4 ~w-2/4 ~bottom-starbmin/starbmax ~right-starrmin/starrmax"
          alt="star"
        />
      )}
    </div>
  );
}
